export default __webpack_public_path__ + "static/live_video-215e2008d100d2544d22f2e9975e2f49.png";